import { setDesignatorStatus } from '../../../utils'

const getters = {
  pfDocs: state => {
    return state.pfDocs
  },
  pfDocsSection: state => {
    let pfDetails = state.pfDocsSection

    if (pfDetails.CanProgressFlow) {
      let mappedDetails = pfDetails?.CanProgressFlow[0]?.fileDetails.map(file => {
        return {
          name: file.pfTitle,
          slNo: file.pfSLNo,
          id: file.pfId,
          status: setDesignatorStatus(file),
          docUrl: file.filePath,
          loading: false,
        }
      })

      let sortedDocs = mappedDetails.sort((a, b) => a.slNo - b.slNo)
      pfDetails.CanProgressFlow[0].fileDetails = sortedDocs
      return pfDetails
    } else return {}
  },
  pfCandidates: state => {
    return state.pfCandidates
  },
  currPage: state => {
    return state.currPage
  },
  pageCount: state => {
    return state.pageCount
  },
  pfActivityCount: state => {
    return state.pfActivityCount
  },
}

export default getters
